// components/MissionVision.jsx
import React, { useState, useEffect } from 'react';
import './MissionVision.css';

const MissionVision = () => {
  const [sectionTitle, setSectionTitle] = useState("");
  const [sectionSubtitle, setSectionSubtitle] = useState("");
  const [missionData, setMissionData] = useState(null);
  const [visionData, setVisionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMissionVisionData();
  }, []);

  const fetchMissionVisionData = async () => {
    try {
      setLoading(true);
      // const response = await fetch('http://localhost/ivtcms/api/rubriques/by-url/Mission-amp-Vision-d-Inovact');
      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Mission-amp-Vision-d-Inovact`,)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.success && data.data) {
        const rubriqueData = data.data;
        
        // 1. Récupérer les informations de la rubrique
        setSectionTitle(rubriqueData.titre || "");
        setSectionSubtitle(rubriqueData.descriptif || "");
        
        // 2. Récupérer les articles (mission et vision)
        if (rubriqueData.articles && rubriqueData.articles.length >= 2) {
          // Chercher l'article "Notre Mission"
          const missionArticle = rubriqueData.articles.find(article => 
            article.titre === "Notre Mission" || article.id_article === "98"
          );
          
          // Chercher l'article "Notre Vision"
          const visionArticle = rubriqueData.articles.find(article => 
            article.titre === "Notre Vision" || article.id_article === "99"
          );
          
          // Traiter les données de la mission
          if (missionArticle) {
            const missionProcessed = processArticleData(missionArticle);
            setMissionData(missionProcessed);
          }
          
          // Traiter les données de la vision
          if (visionArticle) {
            const visionProcessed = processArticleData(visionArticle);
            setVisionData(visionProcessed);
          }
        }
      } else {
        throw new Error('Données de rubrique non disponibles');
      }
      
    } catch (err) {
      console.error('Erreur lors de la récupération des données:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour traiter les données d'un article
  const processArticleData = (article) => {
    let description = "";
    let points = [];
    
    // Vérifier d'abord le descriptif qui contient le texte complet pour la mission
    if (article.descriptif && article.descriptif.trim() !== "") {
      description = article.descriptif.trim();
    }
    // Sinon utiliser le texte
    else if (article.texte) {
      // Nettoyer le texte
      const cleanedText = article.texte.replace(/\r\n/g, ' ');
      
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cleanedText, 'text/html');
        
        // Extraire la description (le premier paragraphe)
        const paragraphs = doc.querySelectorAll('p');
        if (paragraphs.length > 0) {
          description = paragraphs[0].textContent.trim();
          
          // Vérifier s'il y a une liste après
          const list = doc.querySelector('ul');
          if (list) {
            const listItems = list.querySelectorAll('li');
            points = Array.from(listItems).map(item => {
              const text = item.textContent.trim();
              // Séparer le titre et la description si possible
              const colonIndex = text.indexOf(':');
              if (colonIndex > 0) {
                return {
                  title: text.substring(0, colonIndex).trim(),
                  text: text.substring(colonIndex + 1).trim(),
                  icon: "✓"
                };
              } else {
                return {
                  title: text,
                  text: "",
                  icon: "✓"
                };
              }
            });
          }
        }
        
      } catch (parseError) {
        console.warn('Erreur lors du parsing HTML:', parseError);
        
        // Fallback avec regex pour une structure simple
        const pRegex = /<p>(.*?)<\/p>/g;
        const pMatches = [...cleanedText.matchAll(pRegex)];
        if (pMatches.length > 0) {
          description = pMatches[0][1].trim().replace(/&#8230;$/, '');
        }
        
        // Extraire les éléments de liste
        const liRegex = /<li>(.*?)<\/li>/g;
        const liMatches = [...cleanedText.matchAll(liRegex)];
        points = liMatches.map(match => {
          const text = match[1].trim();
          const colonIndex = text.indexOf(':');
          if (colonIndex > 0) {
            return {
              title: text.substring(0, colonIndex).trim(),
              text: text.substring(colonIndex + 1).trim(),
              icon: "✓"
            };
          } else {
            return {
              title: text,
              text: "",
              icon: "✓"
            };
          }
        });
      }
    }
    
    // Si on n'a pas de description, utiliser texte_short et enlever &#8230;
    if (!description && article.texte_short) {
      description = article.texte_short.replace(/&#8230;$/, '');
    }
    
    // Récupérer l'image de l'article
    let imageUrl = "";
    
    // Vérifier d'abord image_principale
    if (article.image_principale) {
      imageUrl = article.image_principale;
    } else if (article.documents && article.documents.length > 0) {
      // Sinon, chercher dans les documents
      const firstImage = article.documents.find(doc => 
        doc.type === 'image' || doc.extension?.match(/(jpg|jpeg|png|gif|webp|avif|svg)$/i)
      );
      if (firstImage) {
        imageUrl = firstImage.url || firstImage.image_principale;
      }
    }
    
    return {
      id: article.id_article,
      title: article.titre || "",
      description: description,
      points: points,
      imageUrl: imageUrl
    };
  };

  if (loading) {
    return (
      <section className="mission-vision-section" id="mission-vision">
        <div className="contenir">
          {/* Placeholder pour le titre */}
          <div className="section-header">
            <div className="loading-placeholder" style={{ 
              height: '40px', 
              width: '300px',
              marginBottom: '1rem',
              background: '#f0f0f0',
              borderRadius: '4px'
            }}></div>
            
            <div className="section-divider"></div>
            
            <div className="loading-placeholder" style={{ 
              height: '20px', 
              width: '80%',
              margin: '0 auto',
              background: '#f0f0f0',
              borderRadius: '4px'
            }}></div>
          </div>

          {/* Placeholder pour la mission */}
          <div className="mission-section">
            <div className="mission-content">
              <div className="loading-placeholder" style={{ 
                height: '150px', 
                marginBottom: '2rem',
                background: '#f0f0f0',
                borderRadius: '8px'
              }}></div>
              
              <div className="key-points">
                {[1, 2, 3].map(i => (
                  <div key={i} className="point-item">
                    <div className="loading-placeholder" style={{ 
                      height: '80px', 
                      background: '#f0f0f0',
                      borderRadius: '8px'
                    }}></div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="mission-image">
              <div className="loading-placeholder" style={{ 
                width: '100%', 
                height: '100%',
                background: '#f0f0f0',
                borderRadius: '8px'
              }}></div>
            </div>
          </div>

          {/* Placeholder pour la vision */}
          <div className="vision-section">
            <div className="vision-image">
              <div className="loading-placeholder" style={{ 
                width: '100%', 
                height: '100%',
                background: '#f0f0f0',
                borderRadius: '8px'
              }}></div>
            </div>
            
            <div className="vision-content">
              <div className="loading-placeholder" style={{ 
                height: '150px', 
                marginBottom: '2rem',
                background: '#f0f0f0',
                borderRadius: '8px'
              }}></div>
              
              <div className="key-points">
                {[1, 2, 3].map(i => (
                  <div key={i} className="point-item">
                    <div className="loading-placeholder" style={{ 
                      height: '80px', 
                      background: '#f0f0f0',
                      borderRadius: '8px'
                    }}></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="mission-vision-section" id="mission-vision">
        <div className="contenir">
          <div className="section-header">
            <h2 className="section-title">Mission & Vision d'Inovact</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle" style={{color: '#ff6b6b'}}>
              Erreur de chargement : {error}
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="mission-vision-section" id="mission-vision">
      <div className="contenir">
        {/* Titre principal */}
        <div className="section-header">
          <h2 className="section-title">{sectionTitle}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            {sectionSubtitle}
          </p>
        </div>

        {/* Section Mission - Image à droite */}
        <div className="mission-section">
          <div className="mission-content">
            <div className="content-header">
              <h3 style={{fontStyle:"italic"}}>{missionData?.title || ""}</h3>
            </div>
            
            <div className="content-body">
              <p className="content-description">
                {missionData?.description}
              </p>
              
              {missionData?.points && missionData.points.length > 0 && (
                <div className="key-points">
                  {missionData.points.map((point, index) => (
                    <div className="point-item" key={index}>
                      <span className="point-icon">{point.icon || "✓"}</span>
                      <div>
                        <h4>{point.title}</h4>
                        <p>{point.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          
          <div className="mission-image">
            {missionData?.imageUrl ? (
              <img 
                src={missionData.imageUrl} 
                alt={`Image pour ${missionData.title}`}
                loading="lazy"
                onError={(e) => {
                  console.error(`Erreur de chargement de l'image: ${missionData.title}`, missionData.imageUrl);
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div style={{ 
                width: '100%', 
                height: '100%',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#666',
                fontSize: '14px'
              }}>
                Image non disponible
              </div>
            )}
          </div>
        </div>

        {/* Section Vision - Image à gauche */}
        <div className="vision-section">
          <div className="vision-image">
            {visionData?.imageUrl ? (
              <img 
                src={visionData.imageUrl} 
                alt={`Image pour ${visionData.title}`}
                loading="lazy"
                onError={(e) => {
                  console.error(`Erreur de chargement de l'image: ${visionData.title}`, visionData.imageUrl);
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div style={{ 
                width: '100%', 
                height: '100%',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#666',
                fontSize: '14px'
              }}>
                Image non disponible
              </div>
            )}
          </div>
          
          <div className="vision-content">
            <div className="content-header">
              <h3 style={{fontStyle:"italic"}}>{visionData?.title || ""}</h3>
            </div>
            
            <div className="content-body">
              <p className="content-description">
                {visionData?.description}
              </p>
              
              {visionData?.points && visionData.points.length > 0 && (
                <div className="key-points">
                  {visionData.points.map((point, index) => (
                    <div className="point-item" key={index}>
                      <span className="point-icon">{point.icon || "🚀"}</span>
                      <div>
                        <h4>{point.title}</h4>
                        <p>{point.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;